export default "__VITE_ASSET__C9iEDYdI__"